import { jsxs as c, jsx as n } from "react/jsx-runtime";
import * as i from "@radix-ui/react-avatar";
import { forwardRef as k } from "react";
import { c as A } from "./cn-DlLpp5ix.js";
const R = {
  xs: 24,
  sm: 28,
  md: 32,
  lg: 40,
  xl: 48
};
function M(t) {
  return typeof t == "number" ? t : R[t];
}
const j = {
  unread: "var(--accent-default)",
  "off-target": "var(--neutral)",
  pending: "var(--magenta)"
};
function F(t, a) {
  switch (t) {
    case "accent":
      return "var(--accent-default)";
    case "identity":
      return a ?? "var(--neutral-bg-strong)";
    case "gradient":
      return "var(--brand-gradient)";
    case "neutral":
    default:
      return "var(--neutral-bg-strong)";
  }
}
function I(t) {
  return t === "neutral" ? "var(--text-primary)" : "var(--text-on-accent)";
}
const T = k(function({
  size: a = "md",
  src: l,
  initials: u,
  tone: d = "neutral",
  identityColor: s,
  badge: e = null,
  alt: f,
  className: h,
  style: g,
  ...m
}, v) {
  const r = M(a), o = d === "identity" && !s ? "neutral" : d, p = F(o, s), y = I(o), b = e ? j[e] : void 0, x = {
    position: "relative",
    display: "inline-flex",
    width: r,
    height: r,
    flexShrink: 0,
    ...g
  }, w = {
    width: "100%",
    height: "100%",
    borderRadius: "var(--radius-full)",
    overflow: "hidden",
    background: p,
    color: y,
    fontFamily: "var(--font-sans)",
    fontSize: r <= 24 ? 10 : r <= 32 ? 12 : 14,
    fontWeight: 700,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center"
  }, S = {
    position: "absolute",
    top: 0,
    right: 0,
    width: Math.max(8, Math.round(r / 4)),
    height: Math.max(8, Math.round(r / 4)),
    borderRadius: "var(--radius-full)",
    background: b,
    border: "2px solid var(--bg-surface)"
  };
  return /* @__PURE__ */ c(
    "span",
    {
      ref: v,
      "data-ls-component": "avatar",
      "data-tone": o,
      "data-size": typeof a == "number" ? `n${a}` : a,
      role: "img",
      "aria-label": f,
      className: A(h),
      style: x,
      ...m,
      children: [
        /* @__PURE__ */ c(i.Root, { style: w, children: [
          l ? /* @__PURE__ */ n(
            i.Image,
            {
              src: l,
              alt: "",
              referrerPolicy: "no-referrer",
              style: { width: "100%", height: "100%", objectFit: "cover" }
            }
          ) : null,
          /* @__PURE__ */ n(i.Fallback, { delayMs: 0, "aria-hidden": "true", children: /* @__PURE__ */ n("span", { "aria-hidden": "true", children: u ?? "" }) })
        ] }),
        e ? /* @__PURE__ */ n("span", { "data-ls-avatar-badge": e, style: S, "aria-hidden": "true" }) : null
      ]
    }
  );
});
T.displayName = "Avatar";
export {
  T as A
};
//# sourceMappingURL=Avatar-ihLwDM5D.js.map
